import React from 'react';

interface DispositionConfig {
  label: string;
  group: string;
  bg: string;
  text: string;
  border: string;
}

const DISPOSITION_MAP: Record<string, DispositionConfig> = {
  no_answer:           { label: 'No Answer',      group: 'Not Reached', bg: 'bg-slate-500/15', text: 'text-slate-400',   border: 'border-slate-500/30' },
  voicemail:           { label: 'Voicemail',       group: 'Not Reached', bg: 'bg-slate-500/15', text: 'text-slate-400',   border: 'border-slate-500/30' },
  wrong_number:        { label: 'Wrong Number',    group: 'Not Reached', bg: 'bg-slate-500/15', text: 'text-slate-400',   border: 'border-slate-500/30' },
  gatekeeper_block:    { label: 'Blocked',         group: 'Blocked',     bg: 'bg-amber-500/15', text: 'text-amber-400',   border: 'border-amber-500/30' },
  not_available:       { label: 'Not Available',   group: 'Blocked',     bg: 'bg-amber-500/15', text: 'text-amber-400',   border: 'border-amber-500/30' },
  hard_rejection:      { label: 'Hard Reject',     group: 'Rejected',    bg: 'bg-red-500/15',   text: 'text-red-400',     border: 'border-red-500/30' },
  soft_rejection:      { label: 'Soft Reject',     group: 'Rejected',    bg: 'bg-red-500/15',   text: 'text-red-400',     border: 'border-red-500/30' },
  interested_future:   { label: 'Future Interest', group: 'Interested',  bg: 'bg-blue-500/15',  text: 'text-blue-400',    border: 'border-blue-500/30' },
  interested_info:     { label: 'Wants Info',      group: 'Interested',  bg: 'bg-blue-500/15',  text: 'text-blue-400',    border: 'border-blue-500/30' },
  interested_callback: { label: 'Callback',        group: 'Interested',  bg: 'bg-blue-500/15',  text: 'text-blue-400',    border: 'border-blue-500/30' },
  interested_meeting:  { label: 'Meeting Set',     group: 'Interested',  bg: 'bg-indigo-500/15', text: 'text-indigo-400', border: 'border-indigo-500/30' },
  interested_referred: { label: 'Referred',        group: 'Interested',  bg: 'bg-blue-500/15',  text: 'text-blue-400',    border: 'border-blue-500/30' },
  converted:           { label: 'Converted',       group: 'Converted',   bg: 'bg-red-500/15',   text: 'text-red-400',     border: 'border-red-500/30' },
};

const DISPOSITION_GROUPS: Record<string, { label: string; color: string; dispositions: string[] }> = {
  'Converted': {
    label: 'Converted',
    color: 'bg-red-400',
    dispositions: ['converted'],
  },
  'Interested': {
    label: 'Interested',
    color: 'bg-blue-400',
    dispositions: ['interested_future', 'interested_info', 'interested_callback', 'interested_meeting', 'interested_referred'],
  },
  'Rejected': {
    label: 'Rejected',
    color: 'bg-amber-400',
    dispositions: ['hard_rejection', 'soft_rejection'],
  },
  'Blocked': {
    label: 'Blocked',
    color: 'bg-purple-400',
    dispositions: ['gatekeeper_block', 'not_available'],
  },
  'Not Reached': {
    label: 'Not Reached',
    color: 'bg-slate-400',
    dispositions: ['no_answer', 'voicemail', 'wrong_number'],
  },
};

interface DispositionBadgeProps {
  disposition?: string | null;
  className?: string;
}

const DispositionBadge: React.FC<DispositionBadgeProps> = ({ disposition, className = '' }) => {
  if (!disposition) return null;
  const config = DISPOSITION_MAP[disposition];
  if (!config) return null;

  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium border ${config.bg} ${config.text} ${config.border} ${className}`}>
      {config.label}
    </span>
  );
};

export default DispositionBadge;
export { DISPOSITION_MAP, DISPOSITION_GROUPS };
